import type { ThemeId } from "@/types";

const THEMES: ThemeId[] = ["dark", "light"];

export function readStoredTheme(fallback: ThemeId): ThemeId {
  const stored = localStorage.getItem("ew-theme");
  return THEMES.includes(stored as ThemeId) ? (stored as ThemeId) : fallback;
}

export function applyTheme(theme: ThemeId): void {
  document.documentElement.classList.remove("dark", "light");
  document.documentElement.classList.add(theme);
  document.documentElement.setAttribute(
    "data-eds-theme",
    theme === "light" ? "light" : "dark",
  );
  localStorage.setItem("ew-theme", theme);
}
